import { CPF_LENGTH, CNPJ_LENGTH } from './constants';

const DOC_LENGTHS: Record<'CPF' | 'CNPJ', number> = { CPF: CPF_LENGTH, CNPJ: CNPJ_LENGTH };

export function isDocIncomplete(docType: 'CPF' | 'CNPJ', docNumber: string): boolean {
  if (!docNumber) return true;
  return docNumber.replace(/\D/g, '').length !== DOC_LENGTHS[docType];
}

export const docLengthMessage = (docType: 'CPF' | 'CNPJ') => `O ${docType} deve ter ${DOC_LENGTHS[docType]} dígitos.`;
